import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {dialogBoxRef} from './ContentRouter';
import PledgeInfo from "../../dashboard/components/PledgeInfo";
import Api, {APIs} from "../../../Api";

interface IProps {

}

export default function DocumentMenu(props: IProps) {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <Button
                id="document-button"
                onClick={handleClick}
            >
                <h5 className="mb-0 pt-0" style={{
                    color: "black",
                    fontWeight: 600
                }}>{"Documents"}</h5>
            </Button>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem
                    sx={{fontWeight: 600, fontSize: "18px"}}
                    onClick={() => {
                        dialogBoxRef?.current?.setContent(<><PledgeInfo/></>)
                        dialogBoxRef?.current?.openDialog("Pledge Information (USD in Million)")
                        handleClose()
                    }}>Pledge Info</MenuItem>
                <MenuItem
                    sx={{fontWeight: 600, fontSize: "18px"}}
                    onClick={() => {
                        const url = Api.getURL(APIs.MoPD_DOCS, {"doc_key": "PDNA"})
                        window.open(url);
                        handleClose()
                    }}>Need Assessment</MenuItem>
                <MenuItem
                    sx={{fontWeight: 600, fontSize: "18px"}}
                    onClick={() => {
                        const url = Api.getURL(APIs.MoPD_DOCS, {"doc_key": "4RF"})
                        window.open(url);
                        handleClose()
                    }}>4RF Framework</MenuItem>
            </Menu>
        </div>
    );
}
